/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Знакомьтесь, общайтесь, встречайтесь",
      "Неверный номер",
      "Скачать приложение",
      "Продолжить через Apple",
      "Продолжить через Facebook",
      "Продолжить через Google",
      "Войти",
      "Регистрация",
      "Чтобы продолжить, введи символы, которые ты видишь:",
      "Продолжить",
      "Введи символы",
      "Проверка безопасности",
      "Обновить",
      "Придумай новый, пароль, который можно легко запомнить:",
      "Сохранить",
      "Подтверди пароль",
      "Пароль не может быть короче {{num}} [[characters:num@1]].",
      "Пароль",
      "Создать новый пароль",
      "Блог Badoo",
      "Карьера",
      "Чат",
      "Города",
      "Настройки cookie",
      "© 2006 – н.в. Bumble. Все права защищены.",
      "Apple и логотип Apple являются товарными знаками компании Apple Inc.{{__EOL__}}Google Play является товарным знаком компании Google LLC.",
      "Скачать",
      "Facebook",
      "Подпишись на нас:",
      "Помощь",
      "Instagram",
      "Язык",
      "LinkedIn",
      "Обзор",
      "Badoo – часть Bumble Inc.",
      "Политика конфиденциальности",
      "Safety Centre",
      "Карта сайта",
      "Закон о современном рабстве",
      "Условия обслуживания",
      "Twitter",
      "Введи свой email или номер телефона, и мы вышлем тебе инструкции по изменению пароля.",
      "Запросить новый пароль",
      "Укажи email или номер телефона",
      "Не помнишь пароль?",
      "Пример для иллюстрации",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Не хочешь дожидаться взаимной симпатии? {{__EOL__}}\n{{__EOL__}}Перейди сразу к самому интересному – более близкому общению, где вы сможете узнать друг друга лучше.",
      "Поболтаем?",
      "Создавая аккаунт, ты соглашаешься с нашими <a class=\"link\" href=\"{{terms_url}}\">«Условиями обслуживания»</a>. Более подробно о том, как мы используем твои данные – в нашей <a class=\"link\" href=\"{{privacy_url}}\">«Политике конфиденциальности»</a>.",
      "Помогаем тебе быть собой <br />и наслаждаться свиданиями.",
      "Мы за свидания с уверенностью.",
      "или",
      "Уже есть аккаунт?",
      "Регистрация по email или номеру телефона",
      "Получай от свиданий то, что хочешь. {{__EOL__}}Без объяснений.",
      "Хочешь просто общаться? Здорово!{{__EOL__}}\nИщешь любовь? Отлично!{{__EOL__}}\n{{__EOL__}}Намерения всегда можно изменить.",
      "Ходить на свидания",
      "Найти любовь",
      "Просто общаться",
      "Знакомься с теми, кто разделяет твои цели.",
      "{{name}}, {{age}}",
      "Твоя безопасность – наш главный приоритет.",
      "В нашем Safety Centre ты найдешь всю информацию о том, как сделать свидания безопасными.",
      "Посетить Safety Centre",
      "Безопасность прежде всего,<br/>всегда, везде.",
      "Мне сразу стало понятно, что всё получится!",
      "Я сначала не ждала вообще ничего серьезного...",
      "Совет, который пригодится всем на Badoo",
      "Истории успеха на Badoo",
      "Читать больше историй успеха",
      "Рейтинг:__CUT__{{num}}",
      "Apple App Store",
      "Доверься нам – с 2006 года мы познакомили друг с другом много миллионов пар.",
      "{{num}}+ МЛН__CUT__загрузок",
      "{{num}}+ МЛН",
      "Магазин Google Play",
      "Мы знаем своё дело.",
      "Войти по email или номеру телефона",
      "Пароль",
      "Не помнишь пароль?",
      "Зарегистрироваться",
      "Нет аккаунта?",
      "Логин",
      "Регистрация"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "символа",
                  "символов",
                  "символам",
                  "символа",
                  "символами",
                  "символах"
            ],
            "many": [
                  "символов",
                  "символов",
                  "символам",
                  "символов",
                  "символами",
                  "символах"
            ],
            "plural": [
                  "символа",
                  "символов",
                  "символам",
                  "символа",
                  "символами",
                  "символах"
            ],
            "singular": [
                  "символ",
                  "символа",
                  "символу",
                  "символ",
                  "символом",
                  "символе"
            ],
            "two": [
                  "символа",
                  "символов",
                  "символам",
                  "символа",
                  "символами",
                  "символах"
            ]
      },
      "day": {
            "few": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "many": [
                  "дней",
                  "дней",
                  "дням",
                  "дней",
                  "днями",
                  "днях"
            ],
            "plural": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "singular": [
                  "день",
                  "дня",
                  "дню",
                  "день",
                  "днём",
                  "дне"
            ],
            "two": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ]
      },
      "hour": {
            "few": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "many": [
                  "часов",
                  "часов",
                  "часам",
                  "часов",
                  "часами",
                  "часах"
            ],
            "plural": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "singular": [
                  "час",
                  "часа",
                  "часу",
                  "час",
                  "часом",
                  "часе"
            ],
            "two": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ]
      },
      "minute": {
            "few": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "many": [
                  "минут",
                  "минут",
                  "минутам",
                  "минут",
                  "минутами",
                  "минутах"
            ],
            "plural": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "singular": [
                  "минута",
                  "минуты",
                  "минуте",
                  "минуту",
                  "минутой",
                  "минуте"
            ],
            "two": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ]
      },
      "month": {
            "few": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "many": [
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцами",
                  "месяцах"
            ],
            "plural": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "singular": [
                  "месяц",
                  "месяца",
                  "месяц",
                  "месяц",
                  "месяцем",
                  "месяце"
            ],
            "two": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ]
      },
      "second": {
            "few": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "many": [
                  "секунд",
                  "секунд",
                  "секундам",
                  "секунд",
                  "секундами",
                  "секундах"
            ],
            "plural": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "singular": [
                  "секунда",
                  "секунды",
                  "секунде",
                  "секунду",
                  "секундой",
                  "секунде"
            ],
            "two": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ]
      },
      "year": {
            "few": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "many": [
                  "лет",
                  "лет",
                  "годам",
                  "лет",
                  "годами",
                  "годах"
            ],
            "plural": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "singular": [
                  "год",
                  "года",
                  "году",
                  "год",
                  "годом",
                  "годе"
            ],
            "two": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
